import { VpButton, VpIcon } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';
import genericImage from '../assets/genericImage.jpeg';
import styles from './styles.module.scss';

export type SmType = {
  id: string;
  label: string;
  startDate: string;
  endDate: string;
  imageURL: string | null;
  price: string;
  currency: string;
  brandLabel?: string;
};

export const SmCard = ({
  sm,
  navigateActionButton,
}: {
  sm: SmType;
  navigateActionButton: () => void;
}) => {
  const { t } = useTranslation();
  const {
    id,
    label,
    startDate,
    endDate,
    brandLabel,
    imageURL,
    price,
    currency,
  } = sm;

  return (
    <div className={styles['spo-sm-card']} data-testid={`sm-card-${id}`}>
      <div className={styles['spo-sm-card-label']}>{label}</div>
      <div className={styles['spo-sm-card-image']}>
        {brandLabel && (
          <div className={styles['spo-sm-card-brand']}>{brandLabel}</div>
        )}
        <img src={imageURL ?? genericImage} alt="super model" />
      </div>
      <div>
        <div className={styles['spo-sm-details']}>
          <span>{t('offer-poster.sm-card.reference_label')}</span>
          <span>{id}</span>
        </div>
        <div className={styles['spo-sm-details']}>
          <span>{t('offer-poster.sm-card.start-date_label')}</span>
          <span>{new Date(startDate).toLocaleDateString('fr-FR')}</span>
        </div>
        <div className={styles['spo-sm-details']}>
          <span>{t('offer-poster.sm-card.expected-date_label')}</span>
          <span>{new Date(endDate).toLocaleDateString('fr-FR')}</span>
        </div>
        <div className={styles['spo-sm-details']}>
          <span>{t('offer-poster.sm-card.price')}</span>
          <span data-testid="sm-card_details_price">
            {Number(price).toFixed(2)} {currency}
          </span>
        </div>
      </div>
      <VpButton
        variant="secondary"
        shape="squared"
        size="small"
        startSlot={<VpIcon name="external-link" />}
        onClick={navigateActionButton}
        data-testid="sm-card_page-link"
      >
        {t('offer-poster.sm-card.page-link')}
      </VpButton>
    </div>
  );
};
